import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

let uri = process.env.REACT_APP_APOLLO_API_URL || 'https://service-transactional.develop.embrix.org/graphql';
if (window._env_ && window._env_.REACT_APP_APOLLO_API_URL) {
  uri = window._env_.REACT_APP_APOLLO_API_URL;
}

// Security #1: attach the bearer token (stored at login) to every GraphQL request.
const authLink = new ApolloLink((operation, forward) => {
  const token =
    typeof window !== 'undefined' && window.localStorage
      ? window.localStorage.getItem('authToken')
      : null;
  operation.setContext(({ headers = {} }) => ({
    headers: token ? { ...headers, Authorization: `Bearer ${token}` } : headers,
  }));
  return forward(operation);
});

// Security #1: on 401 (invalid/expired token), clear it and bounce to login.
const customFetch = (input, init) =>
  fetch(input, init).then(response => {
    if (response.status === 401) {
      if (window.localStorage) window.localStorage.removeItem('authToken');
      if (window.location && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return response;
  });

const httpLink = new HttpLink({ uri, fetch: customFetch });

const client = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions,
});

export default client;
